/**
 * tilemapNav — a tiny navigation channel that lets any component (a
 * `tilemap_ref` node deep inside the React Flow canvas, the catalog panel, the
 * toolbar) request opening/closing the tilemap view without prop-drilling
 * through the shell. EditorShell subscribes to `openUuid` and owns the actual
 * document load + History routing; this store only carries intent.
 *
 * `fromNode` records where the open came from (graph + node uuid) so the shell
 * can return to that node on exit (_docs/tilemap/04 §2 provenance breadcrumbs).
 */

import { createStore } from 'zustand/vanilla';
import { useStore } from 'zustand';

export interface FromNode {
    graphUuid: string;
    nodeUuid: string;
}

interface TilemapNavState {
    openUuid: string | null;
    fromNode: FromNode | null;
    open: (tilemapUuid: string, fromNode?: FromNode | null) => void;
    close: () => void;
}

export const tilemapNav = createStore<TilemapNavState>((set) => ({
    openUuid: null,
    fromNode: null,
    open: (tilemapUuid, fromNode = null) => set({ openUuid: tilemapUuid, fromNode }),
    close: () => set({ openUuid: null, fromNode: null }),
}));

export function useTilemapNav<T>(selector: (s: TilemapNavState) => T): T {
    return useStore(tilemapNav, selector);
}
